import React from 'react';
import _ from 'lodash';
import { useQuery } from '@apollo/client';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import gql from 'graphql-tag';

import { ErrorAlert } from '../ErrorAlert';

const INVALID_AVATAR_VALUES = ['/images', 'images', 'null', 'undefined', '-', 'n/a', 'na'];

const cleanAvatarUrl = (value) => String(value || '').trim();
const isAbsoluteAvatarUrl = (value) => /^(https?:)?\/\//i.test(cleanAvatarUrl(value));
const isValidAvatarUrl = (value) => {
	const avatarUrl = cleanAvatarUrl(value);
	return isAbsoluteAvatarUrl(avatarUrl) && !INVALID_AVATAR_VALUES.includes(avatarUrl.toLowerCase());
};

const USER_AVATAR = gql`
    query SystemUserAvatar(
		$empid: String
	) {
		SystemUserAvatar(
			empid: $empid
		)
    }
`;

const SystemUserAvatar = (props) => {
	const { 
		empid, imgurl, ...rest 
	} = props;
	const propAvatarUrl = isValidAvatarUrl(imgurl) ? cleanAvatarUrl(imgurl) : null;

	const { error, data } = useQuery(USER_AVATAR, { 
		fetchPolicy: 'cache-and-network',
		variables: { empid },
		skip: !!propAvatarUrl || !empid
	});
	if (error) return <ErrorAlert errorMessage={error.message} />;

	const userAvatar = _.has(data, 'SystemUserAvatar') ? data.SystemUserAvatar : null;
	const queryAvatarUrl = _.has(userAvatar, 'imgurl') && isValidAvatarUrl(userAvatar.imgurl) ? cleanAvatarUrl(userAvatar.imgurl) : null;
	const avatarUrl = propAvatarUrl || queryAvatarUrl;
	
	return (
		<Avatar { ...rest } icon={<UserOutlined />} src={avatarUrl} />
	);
};

export default SystemUserAvatar;
